//================================================================
//  Component: Demand Assessment
//================================================================

//  Purpose: This contains the Demand Assessment forms on the Initial Assessment tab

//  Properties:
//    - collectionid = {string, Firestore collection id}
//    - documentid = {string, Firestore document id}

//  Example:
//    <DemandAssessment
//      collectionid={collectionid}
//      documentid={documentid}
//    ></DemandAssessment>    

// ==============================================================

// Libraries
import React from 'react'

//Contexts

// Components
import NewInitiativeForm from './DemandAssessmentForms/NewInitiativeForm';
import ContractRenewalForm from './DemandAssessmentForms/ContractRenewalForm';
import EnhancementForm from './DemandAssessmentForms/EnhancementForm';
import AdditionalLicensesOrOveragesForm from './DemandAssessmentForms/AdditionalLicensesOrOveragesForm';
import DecommissionForm from './DemandAssessmentForms/DecommissionForm';

//Functions

//Images

// CSS
import '../../Task.css';


export default function DemandAssessment({
    collectionid,
    documentid,
    task,
}) {

    //------------------------------------------------------
    //  Variables
    //------------------------------------------------------

    // Extract the request type from the task
    const requestType = task?.requesttype;

    //------------------------------------------------------
    //  Functions
    //------------------------------------------------------

    // Function to render forms based on the request type
    const renderForm = () => {
        switch (requestType) {

            case 'New Initiative or Technology':
                return <NewInitiativeForm collectionid={collectionid} documentid={documentid} task={task}></NewInitiativeForm>;

            case 'Contract Renewal':
                return <ContractRenewalForm collectionid={collectionid} documentid={documentid} task={task}></ContractRenewalForm>;

            case 'Enhancement':
                return <EnhancementForm collectionid={collectionid} documentid={documentid} task={task}></EnhancementForm>;

            case 'Additional Licenses or Overages':
                return <AdditionalLicensesOrOveragesForm collectionid={collectionid} documentid={documentid} task={task}></AdditionalLicensesOrOveragesForm>;

            case 'Decommission':
                return <DecommissionForm collectionid={collectionid} documentid={documentid} task={task}></DecommissionForm>;

            default:
                return <div> Invalid request type.</div>;

        }
    };

    //------------------------------------------------------
    //  HTML
    //------------------------------------------------------

    return (
        <>
            {renderForm()}
        </>
    )
}